// API
export var SEARCH_HINTS_URL = 'SearchHints.ashx';
export var SEARCH_CONTENT_URL = '/api/searchcontent/getsearchcontentbypage';
export var ADD_FAVORITE_URL = '/api/contentlistfavorites/add';
export var REMOVE_FAVORITE_URL = 'api/contentlistfavorites/delete'; // COOKIE

export var FAVORITE_COOKIE_NAME = 'SearchNxFavorite';